module.exports = {"Warn":"警告","Error":"错误","Critical":"危急","Ok":"好的"}


//////////////////
// WEBPACK FOOTER
// ./src/_fdp/core/i18n/bundle/message-cn.json
// module id = pELr
// module chunks = 1